import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchEmployerData, verifyEmployer } from "./EmployerDataAPI"

const initialState = {
    data: [],
    pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
    },
    loading: false,
    error: null,
}

export const fetchEmployerDataAsync = createAsyncThunk("employer/fetch", async (page, { rejectWithValue }) => {
    try {
        return await fetchEmployerData(page)
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const verifyEmployerAsync = createAsyncThunk(
    "employer/verify",
    async ({ uuid, verifyData }, { rejectWithValue }) => {
        try {
            const response = await verifyEmployer(uuid, verifyData)
            return { uuid, ...response }
        } catch (error) {
            return rejectWithValue(error.message)
        }
    }
)

const EmployerDataSlice = createSlice({
    name: "employerData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployerDataAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchEmployerDataAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload.candidates
                state.pagination = action.payload.pagination
            })
            .addCase(fetchEmployerDataAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            .addCase(verifyEmployerAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(verifyEmployerAsync.fulfilled, (state, action) => {
                state.loading = false
                const updatedCandidate = action.payload
                state.data = state.data.map((candidate) =>
                    candidate.uuid === updatedCandidate.uuid ? { ...candidate, is_verified: true } : candidate,
                )
            })
            .addCase(verifyEmployerAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    }
})

export const selectEmployerData = (state) => state.employerData.data
export const selectPagination = (state) => state.employerData.pagination

export default EmployerDataSlice.reducer
